import { Component, Input, OnChanges } from '@angular/core';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { Lightbox, LightboxConfig } from 'ngx-lightbox';

/**
 * service import
 */
import { FunCollectionService } from '../../common-functions/fun-collection.service';

/**
 * SDK IMPOrt
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, EXIT, LIST_ENTRY, LIST_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING, SCREEN_NAME } from 'src/app/constants/app.constants';


@Component({
  selector: 'app-event-speaker-list',
  templateUrl: './event-speaker-list.component.html',
  styleUrls: ['./event-speaker-list.component.scss']
})
export class EventSpeakerListComponent implements OnChanges {
  _albums = [];
  @Input() data;
  @Input() callingfrom;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  speakerData:any='';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  speaker_docq:any;
  openMediaIndex=0;
  mediaModal=false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mediaObj:any=[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  media_type:any;

  public eventStartTime: number;

  public internalSource = '';
  constructor(private dss:DataStorageService, private masterSer: MasterserviceService,public multiLangService:MultiLangService, public mls: NewLanguageService, private _lightbox: Lightbox,private _lighboxConfig: LightboxConfig,private analyticSdk: Analytics, private fcs: FunCollectionService) { }

  ngOnChanges(): void
  {
    console.log(this.data);
    this.internalSource = this.fcs.currentScreename;
    if(this.data.current_index>0)
    { 
      this.speakerDetail(this.data.data[this.data.current_index-1]);
    }
    else {
      this.eventStartTime = new Date().getTime();
      const spearkerListEntry: LIST_ENTRY = {
        entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.data.product_type.toString()],
        entity_code: this.data.product_type_id.toString(),
        current_screen_name: SCREEN_NAME.SPEAKER_LIST,
        source: this.internalSource,
        start_time: this.eventStartTime
      }
      this.internalSource = SCREEN_NAME.SPEAKER_LIST;
      this.eventStartTime = new Date().getTime();
      this.analyticSdk.analyticService.LIST_ENTRY(spearkerListEntry);
    }
  }

  speakerDetail(detail): void {
    console.log(this.data.current_index == 0)
    if (this.data.current_index == 0 || this.data.current_index === '' || this.data.current_index === undefined  ) {
      const speakerListExit:  LIST_EXIT = {
        entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.data.product_type.toString()],
        entity_code: this.data.product_type_id.toString(),
        current_screen_name: SCREEN_NAME.SPEAKER_LIST,
        start_time: this.eventStartTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.LIST_EXIT(speakerListExit);
    }
    this.eventStartTime = new Date().getTime();
    const speakerDetailEntry: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER,
      entity_code: detail.custom_id,
      start_time: this.eventStartTime,
      current_screen_name: SCREEN_NAME.SPEAKER_DETAIL,
      source: this.internalSource
    }
    this.internalSource = SCREEN_NAME.SPEAKER_DETAIL;
    this.analyticSdk.analyticService.ENTRY(speakerDetailEntry);
    this.speakerData = detail;

    if (this.speakerData.speaker_doc != undefined) {

      const x = this.speakerData.speaker_doc.split('/');
      this.speaker_docq = x[x.length - 1];

      const y = this.speaker_docq.split('.');
      this.media_type = y[y.length - 1];

      if (this.media_type == 'pdf') {
        this.media_type = 'document';
      } else if (this.media_type.toLowerCase() == 'jpg' || this.media_type.toLowerCase() == 'jpeg' || this.media_type.toLowerCase() == 'png') {
        this.media_type = 'image';
      }
    }
  }

  backtolist(): void {
    console.log('exit', this.speakerData);
    if (this.speakerData != undefined || this.speakerData !='') {

      // speaker detail exit
      const exitSpeakerDetail: EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER,
        entity_code: 0,
        end_time: new Date().getTime(),
        start_time: this.eventStartTime,
        current_screen_name:  SCREEN_NAME.SPEAKER_DETAIL
      } 
      this.analyticSdk.analyticService.EXIT(exitSpeakerDetail);
    }
    this.speakerData = '';
    if (this.data.current_index != undefined && this.data.current_index > 0) {
      // speaker detail exit
      this.goback();
    }
    else {
      const spearkerListEntry: LIST_ENTRY = {
        entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.data.product_type.toString()],
        entity_code: this.data.product_type_id.toString(),
        current_screen_name: SCREEN_NAME.SPEAKER_LIST,
        source: this.fcs.currentScreename,
        start_time: this.eventStartTime
      }
      setTimeout(() => {
        this.eventStartTime = new Date().getTime();
        this.analyticSdk.analyticService.LIST_ENTRY(spearkerListEntry);
      }, 100);
    }
  }

  goback(): void {
    console.log('here', this.speakerData, this.data.current_index)
    if (this.speakerData) {
      const exitSpeakerDetail: EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER,
        entity_code: this.speakerData?.custom_id,
        end_time: new Date().getTime(),
        start_time: this.eventStartTime,
        current_screen_name:  SCREEN_NAME.SPEAKER_DETAIL
      } 
      this.analyticSdk.analyticService.EXIT(exitSpeakerDetail);
    }
    else if (this.data.current_index === 0 || this.data.current_index === undefined) {
      const speakerListExit:  LIST_EXIT = {
        entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.data.product_type.toString()],
        entity_code: this.data.product_type_id.toString(),
        current_screen_name: SCREEN_NAME.SPEAKER_LIST,
        start_time: this.eventStartTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.LIST_EXIT(speakerListExit);
    }
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.dss.suggAssList = [];
    this.dss.selected_suggAssList = [];

    this.masterSer.showWebModal.next(displayObj);
  }

  viewCertificate(): void {
    this.mediaObj = [];
    const t = {
      media_id: 1,
      media_name: 'certificate',
      media_thumbnail: '',
      media_type: this.media_type,
      media_url: this.speakerData.speaker_doc
    };
    this.mediaObj.push(t);
    this.mediaModal = false;
    if (this.speakerData.speaker_doc != '' && this.speakerData.speaker_doc != undefined) {
      this.mediaModal = true;
    }
  }


  setResetMediaModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.mediaModal = val;
    if (indx != '' && indx != undefined) { this.openMediaIndex = indx; }
  }

  open(src): void {
    this._albums = [{ src: src, thumb: '' }];
    this._lightbox.open(this._albums, 0);
  }

  close(): void {
    this._lightbox.close();
  }

}